import Validator from "js-object-validation";
import { message } from "../common";

export const ModulesValidator = (data) => {
  const validations = {
    name: {
      required: true,
      alpha: true,
    },
  };
  // Error messages
  const messages = {
    name: {
      required: message.Required.replace(":item", "Name"),
      alpha: message.InvalidName.replace(":item", "Name"),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
